import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Shop } from 'src/app/pages/models/type/shop.model';
import { ShopServiceService } from 'src/app/services/shop-service.service';

@Component({
  selector: 'app-all-shop-card',
  templateUrl: './all-shop-card.component.html',
  styleUrls: ['./all-shop-card.component.scss'],
})
export class AllShopCardComponent implements OnInit {
  @Input() shop: Shop;
  @Output() clicked = new EventEmitter();

  constructor(
    private router: Router,
    private shopService: ShopServiceService
  ) {}

  ngOnInit() {}

  goToInfo(id: number) {
    this.router.navigate(['information', id]);
  }

  goToShop(id: number) {
    this.router.navigate(['home/products', id]);
  }
}
